import styled from 'styled-components';
export const MypProgressBarContainer = styled.div`
  .td2 {
    padding: 38px 16px 24px 0px;
  }

  .bulletYetToComplete {
    width: 8px;
    height: 8px;
    border-radius: 1px;
    background: linear-gradient(180deg, #a08fc7 0%, #917ebb 100%);
  }

  .bulletCompleted {
    width: 8px;
    height: 8px;
    border-radius: 1px;
    background: linear-gradient(180deg, #5c4396 0%, #442f76 100%);
  }

  .tdProgressBar {
    width: 333px;
    height: 10px;
    background: #d9d9d9;
    position: relative;
  }

  .tdBarComp {
    /* width: 33%; */
    height: 10px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    background: linear-gradient(180deg, #5c4396 0%, #442f76 60%);
  }

  .tdBarTravel {
    /* width: 66%; */
    height: 10px;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(180deg, #a08fc7 0%, #917ebb 60%);
  }
`;

export const CompeletedWrapper = styled.div`
  display: flex;
  background: #e6fff9;
  font-size: 13px;
  margin-bottom: 5px;
  font-weight: 600;
  max-width: 42%;
  gap: 5px;
`;
